import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";

export type ActionRowType = {
    imageurl?: string;
    heading?: string;
};

const AssetLibraryRow: FunctionComponent<ActionRowType> = ({ heading }) => {
    const navigate = useNavigate();

    return (
        <div
            className="self-stretch shadow-[0px_1px_4px_rgba(0,_0,_0,_0.25)] mobile-action-card-blg-dv rounded-lg bg-surface-bg-primary flex flex-col items-start justify-start p-4 box-border gap-[6px] max-w-full text-left text-base text-colors-text-black font-body-xs-semi-bold cursor-pointer hover:shadow-lg transition-shadow"
            onClick={() => navigate('/asset_registry')}
        >
            <div className="self-stretch flex flex-row items-center justify-between gap-[16px] max-w-full mq950:flex-wrap inner-mobile-action-card-blg-dv">
                <div className="flex-1 flex flex-row items-start justify-start gap-[6px] max-w-full">
                    <h5 className="relative font-bold text-xl-dv mt-0 mb-0 capitalize dark:text-white">
                        {heading}
                    </h5>
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600 dark:text-gray-300">Open Library</span>
                    <svg className="w-5 h-5 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </div>
            </div>
            <div className="self-stretch flex flex-col gap-3 text-sm text-gray-600 dark:text-gray-300">
                <p className="m-0">Browse, manage and track content assets across all brand channels</p>
                <div className="flex gap-4">
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-sky-500"></div>
                        <span>Images & Videos</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-violet-500"></div>
                        <span>Copy & Email</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                        <span>Review Queue</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssetLibraryRow;
